var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from "class-transformer";
import { IsBoolean, IsDate, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
export var UserPermissions;
(function (UserPermissions) {
    UserPermissions["GLOBAL_PROVISIONING"] = "GLOBAL_PROVISIONING";
    UserPermissions["ORG_ADMIN"] = "ORG_ADMIN";
    UserPermissions["RESEARCH_ADMIN"] = "RESEARCH_ADMIN";
    UserPermissions["NONE"] = "NONE";
    UserPermissions["PASSWORD_RESET"] = "PASSWORD_RESET";
    UserPermissions["INVITE_USER"] = "INVITE_USER";
    UserPermissions["RESEARCHER"] = "RESEARCHER";
    UserPermissions["PROVIDER"] = "PROVIDER";
})(UserPermissions || (UserPermissions = {}));
export var APIPermissions;
(function (APIPermissions) {
    APIPermissions["ORG_ADMIN"] = "ORG_ADMIN";
    APIPermissions["PASSWORD_RESET"] = "PASSWORD_RESET";
})(APIPermissions || (APIPermissions = {}));
export var AccountStatus;
(function (AccountStatus) {
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["LOCKED"] = "LOCKED";
    AccountStatus["ADMIN_PASSWORD_RESET"] = "ADMIN_PASSWORD_RESET";
    AccountStatus["INVITED"] = "INVITED";
})(AccountStatus || (AccountStatus = {}));
export var UserType;
(function (UserType) {
    UserType["EXTERNAL_RESEARCHER"] = "EXTERNAL_RESEARCHER";
    UserType["HEALTHCARE_ORGANIZATION"] = "HEALTHCARE_ORGANIZATION";
    UserType["SERVICE_PROVIDER"] = "SERVICE_PROVIDER";
    UserType["PATIENT"] = "PATIENT";
    UserType["PATIENT_READ_ONLY"] = "PATIENT_READ_ONLY";
    UserType["SCREENSHOT_USER"] = "SCREENSHOT_USER";
})(UserType || (UserType = {}));
export class BaseUserDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], BaseUserDto.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], BaseUserDto.prototype, "email", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], BaseUserDto.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], BaseUserDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], BaseUserDto.prototype, "lastName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], BaseUserDto.prototype, "title", void 0);
__decorate([
    IsEnum(UserPermissions, { each: true }),
    __metadata("design:type", Array)
], BaseUserDto.prototype, "permissions", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], BaseUserDto.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], BaseUserDto.prototype, "onChainAddress", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], BaseUserDto.prototype, "avatarUrl", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], BaseUserDto.prototype, "onChainUser", void 0);
__decorate([
    IsEnum(AccountStatus),
    __metadata("design:type", String)
], BaseUserDto.prototype, "accountStatus", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    IsOptional(),
    __metadata("design:type", Object)
], BaseUserDto.prototype, "statusUntil", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], BaseUserDto.prototype, "loginFailureCount", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    __metadata("design:type", Date)
], BaseUserDto.prototype, "passwordExpiresAt", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    __metadata("design:type", Date)
], BaseUserDto.prototype, "passwordUpdatedAt", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], BaseUserDto.prototype, "onboardingComplete", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], BaseUserDto.prototype, "providerId", void 0);
export class InviteUserResult {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], InviteUserResult.prototype, "id", void 0);
export class UsersResponseDto {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], UsersResponseDto.prototype, "total", void 0);
__decorate([
    Type(() => BaseUserDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], UsersResponseDto.prototype, "results", void 0);
